export default "__VITE_ASSET__Cr8EKwBl__"